import React from "react";

import "./Result.css";

const result = props => {
  return (
    <div className="Result">
      <h3>{props.fate}</h3>
      <img src={props.outline} />
    </div>
  );
};

export default result;



// WEBPACK FOOTER //
// ./src/Result/Result.js